import { render, staticRenderFns } from "./app-register-validate.vue?vue&type=template&id=2381f911&scoped=true"
import script from "./app-register-validate.vue?vue&type=script&lang=js"
export * from "./app-register-validate.vue?vue&type=script&lang=js"
import style0 from "./app-register-validate.vue?vue&type=style&index=0&id=2381f911&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2381f911",
  null
  
)

export default component.exports